import { useEffect, useState } from 'react';
import { Theme } from '@newcore/ui/enums/theme';
import { ThemeProviderContext } from './theme-context';

interface ThemeProviderProps {
  children: React.ReactNode;
  defaultTheme?: Theme;
  storageKey?: string;
}

export function ThemeProvider({
  children,
  defaultTheme: _defaultTheme = Theme.SYSTEM,
  storageKey: _storageKey = 'vite-ui-theme',
  ...props
}: ThemeProviderProps) {
  // FORCE LIGHT THEME ONLY - ignore localStorage and system preference
  const [theme] = useState<Theme>(Theme.LIGHT);

  const [resolvedTheme, setResolvedTheme] = useState<Theme.DARK | Theme.LIGHT>(
    Theme.LIGHT
  );

  useEffect(() => {
    const root = window.document.documentElement;

    root.classList.remove(Theme.LIGHT, Theme.DARK);

    // Always apply light theme, ignore any other settings
    root.classList.add(Theme.LIGHT);
    // Sync React theme state with the DOM class applied above.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setResolvedTheme(Theme.LIGHT);
  }, [theme]);

  const value = {
    theme,
    setTheme: (_theme: Theme) => {
      // No-op: theme switching disabled, always light theme
      // Keep function for API compatibility
      // Here we will use the setTheme
    },
    resolvedTheme,
  };

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  );
}
